import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { popoverNavStyles } from "../Navigation/styles";

export const Container = styled.div`
  width: 150px;
  background: ${props => props.theme.backgroundDark};
  padding-top: 12px;
  z-index: 100000;
  padding-bottom: 12px;
  border: ${props => props.theme.border.standard} solid
    ${props => props.theme.border.color};
  border-radius: ${props => props.theme.br.md};

  ${popoverNavStyles}
`;

export const SignupItem = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  padding: 6px 12px;
  margin: 6px 12px 2px;
  background-color: ${props => props.theme.palette[4]};
  border-radius: ${props => props.theme.br.lg};

  p {
    font-size: ${props => props.theme.p3b.fs};
    font-family: ${props => props.theme.p3b.ff};
    color: ${props => props.theme.textLight};
    text-align: center;
  }
`;
